import React from 'react'

const state = {}

const FormContext = React.createContext(state)

export default FormContext
